import { url, tokenRef } from "../index";

// Technical views as PDF + thumbnails (back/routes/viewRender.js).
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem(tokenRef)}` });
const base = (projectId, viewId) => `${url}/projects/${projectId}/documentation/views/${encodeURIComponent(viewId)}`;

// The PDF as a Blob, rendered server-side from the view page itself.
// hash: the view's filter ("level=L1&sys=telecom"), so the print shows it.
export async function downloadViewPdf(projectId, viewId, hash = "") {
  const res = await fetch(`${base(projectId, viewId)}/pdf${hash ? `?hash=${encodeURIComponent(hash)}` : ""}`, { headers: auth() });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).err || "Could not render the PDF");
  return res.blob();
}

// File the render in Document Control (owner side): one row per view,
// each save its next revision.
export async function saveViewPdf(projectId, viewId, hash = "") {
  const res = await fetch(`${base(projectId, viewId)}/pdf/save`, {
    method: "POST", headers: { "Content-Type": "application/json", ...auth() }, body: JSON.stringify({ hash }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.err || "Could not file the PDF");
  return body;
}

// The thumbnail as an object URL, or null while it is still rendering.
export async function viewThumbnailUrl(projectId, viewId) {
  const res = await fetch(`${base(projectId, viewId)}/thumbnail`, { headers: auth() });
  if (res.status === 202) return null;
  if (!res.ok) throw new Error("No thumbnail");
  return URL.createObjectURL(await res.blob());
}
